import ConsentClientFrameworkSDK, {
  BaseInfoModule,
  ConsentStatusParam,
  Region,
} from '@pns-fe/consent-client-framework-sdk';
import type { SDKConfiguration, IInfoModule, ITeaConfig } from '@pns-fe/consent-client-framework-sdk';

import { Consent } from '../interface/cookie-banner';

const REGION_MAP: { [key: string]: Region } = {
  TTP: Region.US_TTP,
  TTP2: Region.US_TTP2,
  GCP: Region.US_EASTRED,
  EU_TTP: Region.EU_TTP,
  MALI_VA: Region.US_EAST,
  ALL_SG: Region.SINGAPORE_CENTRAL,
  EU_TTP2: Region.EU_TTP2,
};

class InfoModule extends BaseInfoModule implements IInfoModule {
  wid: string = '';
  region: string = '';

  constructor({ wid, region }: { wid: string; region: string }) {
    super();
    this.wid = wid;
    this.region = region;
  }

  override getUserInfo() {
    return {
      device_id: this.wid,
      user_country: this.region,
      carrier_region: this.region,
    };
  }
}

let consentSDKInitiated = false;

export async function initConsentSDK({
  config,
  region,
  tenantId,
  consentApiDomain,
  idcRegion,
  disableTea,
  tea,
}: {
  config: Consent;
  region: string;
  tenantId: string;
  consentApiDomain?: string;
  idcRegion: string;
  disableTea: boolean;
  tea?: ITeaConfig;
}): Promise<void> {
  try {
    if (!consentSDKInitiated) {
      consentSDKInitiated = true;

      const { entityKeys: entityKeysMap, wid, ...restConfig } = config;
      const entityKeys: string[] = [];
      Object.keys(entityKeysMap || {}).forEach((key) => {
        const entityKey = entityKeysMap[key] || [];
        entityKeys.push(...entityKey);
      });

      const tenant = tenantId?.startsWith('paas_') ? tenantId.split('paas_')[1] : tenantId;
      const consentConfig = {
        ...restConfig,
        region: REGION_MAP[idcRegion] || REGION_MAP.ALL_SG,
        bid: 'tiktok-cookie-banner',
        ...(disableTea ? { tea: false } : { tea: { disable_auto_pv: true, ...(tea || {}) } }),
        modules: {
          info: new InfoModule({ wid, region }),
        },
        tenant,
      };

      if (consentApiDomain) {
        consentConfig.domain = consentApiDomain;
      }

      await ConsentClientFrameworkSDK.init(consentConfig as unknown as SDKConfiguration);
    }
  } catch (err) {
    console.error(`initConsentSDK failed: errMsg=${(err as Error).message}, config=${JSON.stringify(config)}`);
  }
}

export async function updateConsentRecords(consent: { key: string; value: boolean }[], collectionPointId: string) {
  try {
    const consentRecords = consent.map(({ key, value }) => ({
      key,
      status: value ? ConsentStatusParam.APPROVE : ConsentStatusParam.REJECT,
      collectionPointId,
    }));

    await ConsentClientFrameworkSDK.updateConsentRecords(consentRecords);
  } catch (err) {
    console.error(`updateConsentRecords failed: errMsg=${(err as Error).message}, value=${JSON.stringify(consent)}`);
  }
}
